import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import {
  PieChart,
  buildPieChartSerie,
} from '@delmonicos/shared-design-system-react/src/components/pie-chart/pie-chart';
import { PieChartLegend } from '@delmonicos/shared-design-system-react/src/components/pie-chart/pie-chart-legend';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { PieChartColors } from '@delmonicos/shared-design-system-react/src/models/enums/pie-chart-colors.enum';
import { TransactionReportsStatisticsByTokenTypeModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction-report/transaction-reports-statistics-by-token-type.model';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface ByTokenTypeCardProps {
  data?: TransactionReportsStatisticsByTokenTypeModel;
}

export const ByTokenTypeCard = ({
  data,
}: ByTokenTypeCardProps): React.JSX.Element => {
  const { t } = useTranslation();

  const serie = useMemo(() => {
    if (!data?.value) return [];

    return buildPieChartSerie({
      items: data.value,
      getName: (item) =>
        t(`delmonicos-shared-sdk.enums-token-type.${item.tokenType}`),
      getValue: (item) => item.total ?? 0,
      getColor: (_item, index) =>
        // @ts-ignore
        PieChartColors[`SERIE_${(index % 4) + 1}`],
      othersLabel: t('$.statistics.cards.by-token-type.others'),
      othersIcon: 'wire',
    });
  }, [data, t]);

  return (
    <Card flex={1} gap={GapEnum.M}>
      <AccentTitle
        icon="credit-card-01"
        variant={AccentVariantEnum.Accent2}
        text={t('$.statistics.cards.by-token-type.title')}
      />
      <Stack gap={GapEnum.M}>
        <PieChart serie={serie} chartId="pie-chart-by-token-type" />
        <PieChartLegend serie={serie} />
      </Stack>
    </Card>
  );
};
